module.exports = "/static/media/voicemailInbox.391b1f38.svg";